// extracted by mini-css-extract-plugin
module.exports = {"LegalDisclaimer_contentCard":"LegalDisclaimer_LegalDisclaimer_contentCard__1Fs-N","Content":"LegalDisclaimer_Content__1JZWb"};